import { Identifiable, List } from "@planzone/dto";

function canResize(current: string, next: string) {
  return !!current ? new Date(next) > new Date(current) : false;
}

function resizeList(
  list: Identifiable<List>,
  endDate: string,
): Identifiable<List> {
  return {
    ...list,
    endDate: canResize(list.endDate, endDate) ? endDate : list.endDate,
  };
}

export { resizeList, canResize };
